import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="category-toggle"
export default class extends Controller {
  static targets = ["selector"]

  connect() {
    // Listen for changes on radio buttons
    const radioButtons = document.querySelectorAll('input[name="discord_setup[create_archive_category]"]')
    radioButtons.forEach(radio => {
      radio.addEventListener('change', this.toggleSelector.bind(this))
    })
    
    // Set initial state
    this.toggleSelector()
  }

  toggleSelector() {
    const createNewSelected = document.querySelector('#create_new_category')?.checked
    
    if (this.hasSelectorTarget) {
      if (createNewSelected) {
        // Hide the selector when creating new category
        this.selectorTarget.style.display = 'none'
        this.selectorTarget.querySelector('select')?.removeAttribute('required')
      } else {
        // Show the selector when using existing category
        this.selectorTarget.style.display = 'block'
        this.selectorTarget.querySelector('select')?.setAttribute('required', 'required')
      }
    }
  }
}